import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`;

export const Title = styled.p`
  ${typographyV2.titleBase};
`;

export const Message = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  margin: 4px 0px 16px;
`;
